import { render, staticRenderFns } from "./ProgressWidgetPagination.vue?vue&type=template&id=87133ac2"
import script from "./ProgressWidgetPagination.vue?vue&type=script&lang=js"
export * from "./ProgressWidgetPagination.vue?vue&type=script&lang=js"
import style0 from "./ProgressWidgetPagination.vue?vue&type=style&index=0&id=87133ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports